import $ from "jquery";

import Request from '../../components/request';
import Utils from '../../components/utils';
import Vars from "../../vars";

class Transaction {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    };

    _elems = {
        $content : $()
    };

    _const = {
        entities : 'transactions',
        entity   : 'transaction',
        id       : 'order_id'
    };

    _args = {
        page  : '',
        title : '',
        id    : 0
    };

    _state = {
        items : ''
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page  = args.page  || self._args.page;
        self._args.title = args.title || self._args.title;
        self._args.id    = args.id    || self._args.id;
    };

    _list = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items   = response[self._const.entities];

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : 'Мой кошелек',
                            href  : '#cash'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._args.page, {
                    breadcrumbs : breadcrumbs,
                    view        : Vars.views.tile,
                    columns     : 2,
                    entity      : self._const.entity,
                    entities    : self._const.entities,
                    actions     : false,
                    group       : false,
                    items       : self._state.items.sort(function(a, b){
                        return Date.parse(b.created_at) - Date.parse(a.created_at);
                    }),
                    item_id     : self._const.id,
                    detail      : true,
                    prefix      : 'cash/',
                    card        : function(entity, item) {
                        return Utils.renderProfileTemplate(entity, {
                            item   : item,
                            mode   : self._args.page
                        });
                    }
                }));
            }
        });
    };

    _item = () => {
        let self = this;

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.id,
            done: function(response) {
                loader.decrease();
                $(window).scrollTop(0);

                self._state.item = response[self._const.entity];

                let breadcrumbs = self.profile.template('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : 'Мои транзакции',
                            href  : '#transactions'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._args.page, {
                    breadcrumbs : breadcrumbs,
                    entity      : self._const.entity,
                    item        : self._state.item,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate(entity, {
                            [self._const.entity] : item,
                            mode                 : self._args.page
                        });
                    }
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;
    };

    _bindUI = () => {
        let self = this;
    };

    _init = () => {
        let self = this;

        self._bindElements();
        if(!self._elems.$content.length) return;

        if (self._args.page === Vars.page.list) {
            self._list();
        } else if (self._args.page === Vars.page.item) {
            self._item();
        }
    }
}

export default Transaction;